RivalIQ.module('landscape', function (module, App, Backbone, Marionette, $, _, window) {

    'use strict';

    let overLandscapeLimitModal = null;
    let companyLandscapeAddModal = null;

    function getMaxLandscapes() {
        const plan = RivalIQ.state.account.get('plan');
        return plan.max_landscapes;
    }

    /**
     * Returns a boolean indicating if the current account is at their
     * landscape limit.
     * @returns {*|boolean}
     */
    function isAtLandscapeLimit() {
        const landscapes = RivalIQ.state.user.get('landscapes');
        const maxLandscapes = getMaxLandscapes();

        // plans with unlimited landscapes have maxLandscapes set to 0
        return (maxLandscapes > 0 && landscapes.length >= maxLandscapes);
    }

    /**
     * Opens or creates an add modal for landscape, or company.
     * @param createLandscape
     */
    function openOrCreateAddModal(createLandscape, options) {

        // NOTE if we are creating a landscape and this account is at their
        // limit then we should show a completely different modal to upsell
        if (createLandscape && isAtLandscapeLimit()) {

            if (!overLandscapeLimitModal) {
                const plan = RivalIQ.state.account.get('plan');

                overLandscapeLimitModal = new module.views.OverLandscapeLimitModal({
                    model: new Backbone.Model({
                        maxLandscapes: plan.max_landscapes
                    })
                });

                $(document.body).append(overLandscapeLimitModal.$el);
            }

            return overLandscapeLimitModal.render();
        }

        if (createLandscape) {
            RivalIQ.execute('show:modal', new module.views.NewLandscapeModal(options));
        } else {
            if (!companyLandscapeAddModal) {
                companyLandscapeAddModal = new module.views.CompanyLandscapeAddModal();
                $(document.body).append(companyLandscapeAddModal.$el);
            }

            companyLandscapeAddModal.createLandscape = createLandscape;
            companyLandscapeAddModal.render();
        }
    }

    /**
     * Loads the landscape specified by id.
     * @param landscapeId
     */
    function load(landscapeId, redirect) {

        let redirectUrl = redirect;
        if (!redirectUrl) {
            const urlBasepath = App.state.product.get('urlBasepath');

            // This gives the currently loaded curation component a chance to change the url we'll start on in the new landscape.
            const newUrl = _.result(RivalIQ.curation, 'getLandscapeChangeRedirectUrl') || window.location.href;

            redirectUrl = encodeURIComponent(newUrl.replace(urlBasepath, ''));
        }

        window.location.href = `/api/setActiveLandscape/${landscapeId}?url=${redirectUrl}`;
    }

    /**
     * Unfollows a company (in the current landscape) specified by id.
     * @param id
     * @param callback
     * @returns {*}
     */
    function unfollowCompany(id, callback) {
        const deferred = App.utils.async.callbackToDeferred(callback);

        return module.unfollow({
            companyId: id
        })
            .done(function () {
                // NOTE we cannot use the variable `companies` here or we will
                // shadow a DOM element with the corresponding id
                const companyData = RivalIQ.state.landscape.get('companies');
                const company = companyData.get(id);
                companyData.remove(company);
                RivalIQ.state.landscape.trigger('company:remove');

                deferred.resolve.apply(deferred, arguments);
            })
            .fail(deferred.reject);
    }

    function adjustCompanyLimits(data) {
        const companyLimits = _.get(data, 'companyLimits');
        if (companyLimits) {
            RivalIQ.state.account.set('landscapeCompanyLimits', companyLimits);
            RivalIQ.state.account.set('companyLimits', companyLimits.credits);
        }
    }

    function changeCompanySetIfNeeded(companyId) {
        // If the current company set is show only for this unfollowed company, change the companySet to All Companies.
        const companySetDescriptor = RivalIQ.state.view.get('companySetDescriptor');
        if (companyId === RivalIQ.state.utils.getCompanyIdFromSetId(companySetDescriptor)) {
            const updatedAttributes = {
                companySetDescriptor: null
            };
            RivalIQ.state.view.set(updatedAttributes);
        }
    }

    /**
     * Follow a company by id or URL for a specified landscape, or active.
     * @param {object} options
     * @returns {$.Deferred}
     */
    module.follow = function (options) {
        const url = [
            '/api/landscapes',
            _.get(options, 'landscapeId', RivalIQ.state.landscape.id),
            'companies'
        ].join('/');

        return $.post(url, _.omit(options, 'landscapeId'))
            .then(function (data) {
                return new RivalIQ.models.Company(data);
            });
    };

    /**
     * Unfollows a company by id for a specified landscape, or active.
     * @param {object} options
     * @returns {$.Deferred}
     */
    module.unfollow = function (options) {
        const companyId = _.get(options, 'companyId');
        const url = [
            '/api/landscapes',
            _.get(options, 'landscapeId', RivalIQ.state.landscape.id),
            'companies',
            companyId
        ].join('/');

        return $.ajax({
            url: url,
            type: 'DELETE'
        })
            .done((data) => {
                adjustCompanyLimits(data);
                changeCompanySetIfNeeded(companyId);
            });
    };

    module.onCompanyAdded = function (company, isForCurrentLandscape) {
        RivalIQ.state.account.incrementLifetimeCompanyAddCount();
        adjustCompanyLimits(company);
        if (isForCurrentLandscape) {
            const companyData = RivalIQ.state.landscape.get('companies');

            // NOTE if this is the first company in the landscape then we need
            // to make sure to appropriately set the `focusCompanyId` in view
            // state. we also want to do this first so that UI triggered on
            // company add behaves correctly
            if (_.size(companyData) === 0) {
                RivalIQ.state.view.set({
                    focusCompanyId: company.id
                }, {
                    silent: true
                });
            }

            companyData.add(_.omit(company, 'companyLimits'));

            // NOTE: this will force the data freshness spinner to spin
            RivalIQ.state.landscape.set('companyAdded', true);
            RivalIQ.state.landscape.pollForNewCompanyData();
            RivalIQ.state.landscape.trigger('company:added');

            // only show the back fill alert if we don't have a last rollup date yet
            if (!company.rollup_data_last_updated_at) {
                RivalIQ.execute('alert:info', RivalIQ.str('backfill_alert_info', company.name));
            }

            // If a company set filter is set, we're going to clear it and let them know.
            if (RivalIQ.state.view.get('companySetDescriptor') !== RivalIQ.state.companySets.none) {
                RivalIQ.state.view.set({
                    // TODO clean up use of tag here
                    tag: RivalIQ.state.companySets.none,
                    companySetDescriptor: RivalIQ.state.companySets.none
                });
                const message = '<p>We cleared the company set filter to show all companies.</p>';
                RivalIQ.execute('alert:info', message);
            }
        }
    };

    // NOTE we need to listen to company adds so that we can appropriately add
    // a local copy in state, if we do not do this then bad things can occur
    // (e.g., in /companies after adding a new company to your landscape an
    // error will be thrown when/if you try to make the new company your focus)
    App.listenTo(App, 'landscape:company:added', module.onCompanyAdded);

    App.commands.setHandler('landscape:load', load);
    App.commands.setHandler('landscape:add', function (options) {
        openOrCreateAddModal(true, options);
    });
    App.commands.setHandler('landscape:company:add', _.bind(openOrCreateAddModal, null, false));
    App.commands.setHandler('landscape:company:remove', unfollowCompany);

}, window);
